import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Timer from 'react-compound-timer';
import { InputGroup } from 'react-bootstrap';
import Button from './Button';
import NumberPicker from 'react-widgets/lib/NumberPicker';
import FormField from './FormField';
import { colorMap } from '../../helpers/colors';


const withTimer = timerProps => WrappedComponent => wrappedComponentProps => (
    <Timer {...timerProps}>
      {timerRenderProps =>
        <WrappedComponent {...wrappedComponentProps} timer={timerRenderProps} />}
    </Timer>
  );


class MinutesInput extends Component {
    constructor(props) {
        super(props);
        this.playClickAction = this.playClickAction.bind(this);
        this.renderTimerComponent = this.renderTimerComponent.bind(this);
        this.stopCounter = this.stopCounter.bind(this);
        this.state = {
            playIcon: "time"
        };
    }

    componentDidMount() {
        const { setTime, pause } = this.props.timer;
        const { field } = this.props;
        const minutes = (field.value || field.defaultValue || 0) * 60000;
        setTime(minutes);
        pause();
    }

    componentWillUnmount() {
        this.stopCounter();
    }

    stopCounter() {
        const { getTime, pause } = this.props.timer;
        const { field, onStateChange, increment = 1 } = this.props;
        pause();
        const time = getTime();
        // Convert to minutes
        const minutes = Math.ceil(time / (60000 * increment)) * increment;
        field.onChange({
            target: {
                name: field.name,
                value: minutes
            }
        });

        this.setState({playIcon: "time"});
        if (onStateChange) { onStateChange("STOPPED"); }
    }

    startCounter() {
        const { setTime, start } = this.props.timer;
        const { field, onStateChange } = this.props;
        const minutes = (field.value || 0) * 60000;
        setTime(minutes);
        start();
        this.setState({playIcon: "stop"});
        if (onStateChange) { onStateChange("PLAYING"); }
    }

    playClickAction() {
        const { getTimerState } = this.props.timer;
        const state = getTimerState();
        switch (state) {
            case "INITED":
            case "PAUSED":
                this.startCounter();
                return;

            case 'PLAYING':
                this.stopCounter();
                return;

            default:
                return;
        }
    }

    renderNumberInput() {
        const {required, field, help, label, loading, disabled, defaultValue} = this.props;
        const value = field.value || defaultValue || 0;
        return (
            <FormField required={required} field={field} help={help} loading={loading} label={label}>
            <InputGroup>
                <NumberPicker
                    onChange={value => {
                        field.onChange({
                            target: {
                                value,
                                name: field.name,
                            },
                        });
                    }}
                    onBlur={_ => {
                        if (field.onBlur) {
                            field.onBlur({
                                target: {
                                    value: field.value,
                                    name: field.name,
                                }
                            });
                        }
                    }}
                    value={value}
                    disabled={disabled}
                    id={field.name}
                />
                <InputGroup.Addon>
                <Button
                    style={{
                        marginRight: -15,
                        marginTop: -17,
                        marginBottom: -15,
                        height: 35,
                    }}
                    icon={this.state.playIcon}
                    tooltip={this.state.playIcon == "time" ? "Start Timer" : "Stop Timer"}
                    onClick={this.playClickAction}
                    disabled={disabled}
                />
                </InputGroup.Addon>
            </InputGroup>
            </FormField>
        );
    }

    renderTimerComponent() {
        const {required, field, help, label, loading, disabled} = this.props;
        return (
            <FormField required={required} field={field} help={help} loading={loading} label={label}>
            <InputGroup>
                <Timer.Minutes /> Min <Timer.Seconds /> Sec
                <InputGroup.Addon>
                <Button
                    style={{
                        marginRight: -15,
                        marginTop: -17,
                        marginBottom: -15,
                        height: 35,
                    }}
                    iconStyle={{color: `rgb(${colorMap['red']})`}}
                    icon={this.state.playIcon}
                    tooltip={this.state.playIcon == "time" ? "Start Timer" : "Stop Timer"}
                    onClick={this.playClickAction}
                    disabled={disabled}
                />
                </InputGroup.Addon>
            </InputGroup>
            </FormField>
        );
    }

    render() {
        if (this.state.playIcon == "time") {
            return this.renderNumberInput();
        } else {
            return this.renderTimerComponent();
        }
    }
};

MinutesInput.propTypes = {
    field: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    onStateChange: PropTypes.func,
    increment: PropTypes.int
};

const MinutesInputHOC = withTimer({
    lastUnit: "m",
    startImmediately: false,
    direction: 'forward'
})(MinutesInput);

export default MinutesInputHOC;